
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.0001 1.10156C6.41133 1.10156 4.36506 1.6138 2.9887 2.99017C1.61234 4.36653 1.1001 6.4128 1.1001 9.00156V15.0016C1.1001 17.5903 1.61234 19.6366 2.9887 21.013C4.36506 22.3893 6.41133 22.9016 9.0001 22.9016H15.0001C17.5889 22.9016 19.6351 22.3893 21.0115 21.013C22.3879 19.6366 22.9001 17.5903 22.9001 15.0016V9.00156C22.9001 6.4128 22.3879 4.36653 21.0115 2.99017C19.6351 1.6138 17.5889 1.10156 15.0001 1.10156H9.0001ZM2.9001 9.00156C2.9001 6.59033 3.38786 5.1366 4.26149 4.26296C5.13513 3.38932 6.58886 2.90156 9.0001 2.90156H15.0001C17.4113 2.90156 18.8651 3.38932 19.7387 4.26296C20.6123 5.1366 21.1001 6.59033 21.1001 9.00156V15.0016C21.1001 17.4128 20.6123 18.8665 19.7387 19.7402C18.8651 20.6138 17.4113 21.1016 15.0001 21.1016H9.0001C6.58886 21.1016 5.13513 20.6138 4.26149 19.7402C3.38786 18.8665 2.9001 17.4128 2.9001 15.0016V9.00156ZM11.2603 13.3384L11.1033 17.0016H12.8969L12.7399 13.3384L15.6825 15.3262L16.5834 13.6769L13.459 12.0016L16.5834 10.3262L15.6825 8.6769L12.7399 10.6648L12.8969 7.00156H11.1033L11.2603 10.6648L8.31771 8.6769L7.41675 10.3262L10.5412 12.0016L7.41675 13.6769L8.31771 15.3262L11.2603 13.3384Z","fill":"#16171F"}})])
          )
        }
      }
    